module.exports = __webpack_public_path__ + "static/cg_role_178_0008894d169.wav";